<template>
  <div v-if="!initialized">
    <b-loading :model-value="true" />
  </div>
  <Modal
    v-else
    :has_parent="false"
    :is_show_footer="false"
    :is_show_header="false"
    :is_small="false"
    @actionCancel="$parent.$parent.close"
    @actionPrimary="$parent.$parent.close"
  >
    <template #content>
      <div class="bg-white">
        <header class="media">
          <div class="media-left grow">
            <div class="content">
              <div class="title is-5">
                {{ $t('navbar.topnavbar.selectTeam') }}
              </div>
              <div class="subtitle is-6 has-text-grey-light">
                {{ email_address }}
              </div>
            </div>
          </div>
          <div class="media-right">
            <img
              alt="logo-ziggu"
              src="../../../assets/images/Ziggu_Logo_Green.png"
              style="width: 100px"
            />
          </div>
        </header>

        <SelectTenant />

        <footer
          v-if="!$_.isEmpty(current_user)"
          class="mt-4 flex"
          style="justify-content: flex-end"
        >
          <ButtonTertiary
            action="sign_out"
            @onClick="emitter.$emit('logout')"
          >
            {{ $t('navbar.topnavbar.logout') }}
          </ButtonTertiary>
        </footer>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/app/shared_components/modals/TheModal.vue';
import { mapActions, mapGetters } from 'vuex';
import { PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';
import { LOGIN_PAGE_NOTIFICATIONS, VITE_ENV_REVIEW } from '@/app/data/general_constants';
import { ZIGGU_PARENT_URL, zigguProfileTenantURL } from '@/app/util/urls';
import SelectTenant from '@/app/shared_components/SelectTenant.vue';

export default {
  name: 'SelectTenantModal',

  components: {
    SelectTenant,
    Modal,
  },

  data() {
    return {
      initialized: false,
      PROFILE_TYPES,
      zigguProfileTenantURL,
    };
  },

  computed: {
    ...mapGetters([
      'current_is_impersonation',
      'current_profile',
      'current_user',
      'current_user_customers',
      'current_user_employees',
      'current_user_partners',
      'current_user_supervisors',
      'current_user_clients',
      'current_user_projects',
      'current_user_tenants',
      'current_user_profiles',
    ]),

    email_address() {
      return this.is_parent_domain
        ? this.current_user.attributes.email_address
        : this.current_profile.attributes.email_address;
    },

    is_parent_domain() {
      return ZIGGU_PARENT_URL === window.location.origin;
    },

    origin() {
      return window.location.origin;
    },

    subdomain() {
      let _subdomain = null;
      const parts = window.location.host.split('.');
      if (import.meta.env.VITE_ENV === VITE_ENV_REVIEW) {
        if (parts.length > 3) [_subdomain] = parts;
      } else if (parts.length === 3) {
        [_subdomain] = parts;
      }
      return _subdomain;
    },

    profiles() {
      const profiles = [
        Object.values(this.current_user_supervisors),
        Object.values(this.current_user_employees),
        Object.values(this.current_user_customers),
        Object.values(this.current_user_partners),
      ];
      return [].concat(...profiles);
    },
  },

  async created() {
    await this.fetchProfiles();
  },

  methods: {
    ...mapActions(['FETCH_USER_PROFILES', 'LOGOUT_USER']),

    urlTenant(tenant) {
      const profile = this.getProfile(tenant);
      const url = this.zigguProfileTenantURL(profile, tenant);
      // append meta query params on impersonation for non-supervisor profiles
      if (this.current_is_impersonation && tenant.attributes.subdomain !== 'supervisor') {
        return `${url}?_profile_type=${profile.type}&_profile_id=${profile.id}`;
      }
      return url;
    },

    getProfile(tenant) {
      if (tenant.attributes.name === 'supervisor') return _.values(this.current_user_supervisors)[0];

      const client_id =
        tenant.attributes.tenantable_type === RECORD_TYPE.PROJECT
          ? this.current_user_projects[tenant.attributes.tenantable_id].attributes.client_id
          : tenant.attributes.tenantable_id;
      return _.find(this.profiles, ['attributes.client_id', client_id]);
    },

    getHostname(url) {
      return new URL(url).hostname;
    },

    async fetchProfiles() {
      await this.FETCH_USER_PROFILES({});
      this.initialized = true;
    },
  },
};
</script>
